export enum StorageAccountKind {
    BlockBlobStorage = 'BlockBlobStorage',
    BlobStorage = 'BlobStorage',
    FileStorage = 'FileStorage',
    GeneralPurposeV2 = 'StorageV2',
    GeneralPurposeV1 = 'Storage'
}
